import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiException } from '../services/api.services';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false
})
export class ErrorPageComponent {
  @Input() errorTitle: string = 'Error';
  @Input() error: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute) {
    let error = this.router.getCurrentNavigation()?.extras?.state?.error;

    if (!error)
      error = this.route.data.subscribe(d => this.setError(d['error']));
    else
      this.setError(error);
  }

  private setError(err: any) {
    let error = 'An unexpected error occurred.';

    if (err) {
      if (err instanceof ApiException) {
        error = `Server responsed with status=${err.status}.\n`
        error += err.message;

        if (!environment.production) {
          if (err.stack) {
            error += '\n';
            error += err.stack;
          }
        }
      }
      else if (err instanceof Error) {
        error = err.message;

        if (!environment.production) {
          if (err.stack) {
            error += '\n';
            error += err.stack;
          }
        }
      }
      else if (typeof err === 'string') {
        error = err;
      }
      else if ('error' in err) {
        this.setError(err.error);
        return;
      }
      else {
        if (!environment.production) {
          try {
            error = JSON.stringify(err);
          }
          catch {
            error = '' + err;
          }
        }
      }
    }

    this.error = error;
  }
}
